import React from 'react';
import Hero from '../components/Hero/Hero';
import QueryAI from '../components/QueryAI/QueryAI';
import Projects from '../components/Projects/Projects';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <QueryAI />
      <Projects />
      <About />
      <Contact />
    </main>
  );
};

export default HomePage; 